module.exports = __webpack_public_path__ + "media/introducePageThree_bg.dd1b0c48.mp3";